<template>
  <div class="wrap">
    <div class="side-menu">
      <div class="logo" @click="$router.push('/home')">
        <img :src="require('@/assets/layoutHome/header-logo.png')" />
      </div>
      <div class="menu-list">
        <div :class="['item', activeIndex == 0 ? 'active' : '']">
          <div class="icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
            >
              <path
                d="M16.6203 19.5714L7.37343 19.5714C7.0359 19.5714 6.61439 19.5294 6.3313 19.1983C6.10266 18.9301 6 18.5278 6 17.8897L6 6.76731C6 5.74311 6.57861 5 7.37343 5L18 5L18 5.48464L7.37343 5.48464C7.12767 5.48464 6.91147 5.59772 6.7466 5.81096C6.56773 6.04359 6.46818 6.3796 6.46662 6.75762C6.4744 6.85616 6.5895 8.06129 7.37654 8.07422C8.40778 8.09199 17.6718 8.05645 17.7651 8.05645L18 8.05483L18 17.8914C18 18.3081 17.9269 18.6555 17.7822 18.9236C17.6236 19.2193 17.2938 19.5714 16.6203 19.5714ZM6.46662 8.10653L6.46662 17.8914C6.46662 18.3873 6.53662 18.7104 6.67971 18.8768C6.80415 19.0222 7.01724 19.0868 7.37343 19.0868L16.6203 19.0868C16.8459 19.0868 17.5334 19.0868 17.5334 17.8914L17.5334 8.5427C16.0775 8.54755 8.3129 8.57662 7.36876 8.56047C7.00635 8.55401 6.69993 8.39892 6.46662 8.10653Z"
                stroke="currentColor"
                stroke-width="0.5"
                stroke-linejoin="round"
              ></path>
              <path
                d="M7 6.5249L17.4057 6.5249L17.4057 7.00954L7 7.00954L7 6.5249Z"
                stroke="currentColor"
                stroke-width="0.5"
                stroke-linejoin="round"
              ></path>
              <path
                d="M9 16.533L14.4439 10.8789L14.9012 11.3539L9.45574 17.008L9 16.533Z"
                stroke="currentColor"
                stroke-width="0.5"
                stroke-linejoin="round"
              ></path>
              <path
                d="M14.4439 17.008L9 11.3539L9.45574 10.8789L14.9012 16.5346L14.4439 17.008Z"
                stroke="currentColor"
                stroke-width="0.5"
                stroke-linejoin="round"
              ></path>
            </svg>
          </div>
          <div class="label">错题本</div>
        </div>
        <div class="item">
          <div class="icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
            >
              <path
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linejoin="round"
                stroke-linecap="round"
                d="M5 12C5 15.866 8.13401 19 12 19C13.4993 19 14.8885 18.5287 16.0275 17.7261L19 18L19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12"
              ></path>
              <path
                d="M15 10.25L9 10.25Q8.92613 10.25 8.85368 10.2644Q8.78123 10.2788 8.71299 10.3071Q8.64474 10.3354 8.58332 10.3764Q8.5219 10.4174 8.46967 10.4697Q8.41744 10.5219 8.3764 10.5833Q8.33536 10.6447 8.30709 10.713Q8.27882 10.7812 8.26441 10.8537Q8.25 10.9261 8.25 11Q8.25 11.0739 8.26441 11.1463Q8.27882 11.2188 8.30709 11.287Q8.33536 11.3553 8.3764 11.4167Q8.41744 11.4781 8.46967 11.5303Q8.5219 11.5826 8.58332 11.6236Q8.64474 11.6646 8.71299 11.6929Q8.78123 11.7212 8.85368 11.7356Q8.92613 11.75 9 11.75L15 11.75Q15.0739 11.75 15.1463 11.7356Q15.2188 11.7212 15.287 11.6929Q15.3553 11.6646 15.4167 11.6236Q15.4781 11.5826 15.5303 11.5303Q15.5826 11.4781 15.6236 11.4167Q15.6646 11.3553 15.6929 11.287Q15.7212 11.2188 15.7356 11.1463Q15.75 11.0739 15.75 11Q15.75 10.9261 15.7356 10.8537Q15.7212 10.7812 15.6929 10.713Q15.6646 10.6447 15.6236 10.5833Q15.5826 10.5219 15.5303 10.4697Q15.4781 10.4174 15.4167 10.3764Q15.3553 10.3354 15.287 10.3071Q15.2188 10.2788 15.1463 10.2644Q15.0739 10.25 15 10.25ZM13 13.25L9 13.25Q8.92613 13.25 8.85368 13.2644Q8.78123 13.2788 8.71299 13.3071Q8.64474 13.3354 8.58332 13.3764Q8.5219 13.4174 8.46967 13.4697Q8.41744 13.5219 8.3764 13.5833Q8.33536 13.6447 8.30709 13.713Q8.27882 13.7812 8.26441 13.8537Q8.25 13.9261 8.25 14Q8.25 14.0739 8.26441 14.1463Q8.27882 14.2188 8.30709 14.287Q8.33536 14.3553 8.3764 14.4167Q8.41744 14.4781 8.46967 14.5303Q8.5219 14.5826 8.58332 14.6236Q8.64474 14.6646 8.71299 14.6929Q8.78123 14.7212 8.85368 14.7356Q8.92613 14.75 9 14.75L13 14.75Q13.0739 14.75 13.1463 14.7356Q13.2188 14.7212 13.287 14.6929Q13.3553 14.6646 13.4167 14.6236Q13.4781 14.5826 13.5303 14.5303Q13.5826 14.4781 13.6236 14.4167Q13.6646 14.3553 13.6929 14.287Q13.7212 14.2188 13.7356 14.1463Q13.75 14.0739 13.75 14Q13.75 13.9261 13.7356 13.8537Q13.7212 13.7812 13.6929 13.713Q13.6646 13.6447 13.6236 13.5833Q13.5826 13.5219 13.5303 13.4697Q13.4781 13.4174 13.4167 13.3764Q13.3553 13.3354 13.287 13.3071Q13.2188 13.2788 13.1463 13.2644Q13.0739 13.25 13 13.25Z"
                fill-rule="evenodd"
                fill="#9B9DA3"
              ></path>
            </svg>
          </div>
          <div class="label">成长报告</div>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="header">
        <div class="inner-menu"></div>
        <div class="user">
          <div class="photo">
            <img :src="avatarPhoto" width="36" height="36" v-if="avatarPhoto" />
            <img
              v-else
              :src="require('@/assets/img/center/neutral.png')"
              width="36"
              height="36"
            />
          </div>
          <div class="user-menu">
            <el-dropdown @command="handleCommand" placement="top-end">
              <span class="el-dropdown-link" style="font-size: 20px">
                {{ name }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="home">门户首页</el-dropdown-item>
                <el-dropdown-item command="switch"
                  >切换机构/角色</el-dropdown-item
                >
                <el-dropdown-item command="logout">退出</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      <selRoleLogin
        :open.sync="selRoleLoginVisible"
        switch-mode="all"
        @roleLoginClose="selRoleLoginVisible = false"
      ></selRoleLogin>
      <div class="content">
        <keep-alive>
          <router-view> </router-view>
        </keep-alive>
      </div>
    </div>
  </div>
</template>
<script>
import { getToken } from "@/utils/auth";
import { mapGetters } from "vuex";
import selRoleLogin from "@/views/login/selRoleLogin.vue";
export default {
  name: "",
  components: { selRoleLogin },
  props: {},
  data() {
    return {
      selRoleLoginVisible: false,
      activeIndex: 0,
    };
  },
  watch: {},
  computed: {
    hasTaken() {
      if (getToken()) {
        return true;
      } else {
        return false;
      }
    },
    ...mapGetters(["name", "avatar"]),
    avatarPhoto() {
      return this.avatar
        ? process.env.VUE_APP_BASE_API +
            "/system/File/downOssFile?uuid=" +
            this.avatar
        : null;
    },
  },
  created() {},
  mounted() {},
  methods: {
    logout() {
      this.$confirm("确定要退出平台吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$store.dispatch("LogOut").then(() => {
          this.$router.push("/login");
          //location.href = "/";
        });
      });
    },
    handleCommand(command) {
      if (command == "logout") {
        this.logout();
      } else if (command == "switch") {
        if (
          this.$store.state.user.allRoles.length === 1 &&
          this.$store.state.user.roleList.length === 1
        ) {
          let loginRole =
            this.$store.state.user.allRoles[0]?.roleName ||
            sessionStorage.getItem("loginRoleName");
          this.$message({
            message: `当前只有一个角色【${loginRole}】，无需切换！`, // 动态显示角色名称
            type: "warning",
            duration: 3000, // 提示显示时长
            showClose: true, // 显示关闭按钮
            iconClass: "el-icon-info", // 添加图标
          });
        } else {
          this.selRoleLoginVisible = true;
        }

        // this.$router.push({ path: "/sel", query: { switchMode: 'all' } }).catch(() => {});
      } else {
        this.$router.push("/" + command);
      }
    },
  },
};
</script>
<style scoped>
.header .user >>> .el-dropdown {
  color: #333333;
}
.el-dropdown-menu--medium .el-dropdown-menu__item {
  font-size: 24px;
  line-height: 40px;
}
.el-dropdown-menu {
  padding: 12px 0;
  text-align: center;
  min-width: 200px;
}
</style>
<style lang="scss" scoped>
.wrap {
  display: flex;
  background: rgba(246, 247, 252, 1);
  height: 100vh;
  .side-menu {
    width: 237px;
    height: 100vh;
    background: #fff url("../assets/layoutWrongBook/sidebar-bg.png") no-repeat
      bottom right;
    flex-shrink: 0;
    padding: 20px 10px;
    box-sizing: border-box;
    .logo {
      cursor: pointer;
      text-align: center;
      img {
        width: 120px;
        height: auto;
      }
    }
    .menu-list {
      margin-top: 22px;
      .item {
        width: 205px;
        height: 56px;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding: 20px;
        color: rgba(155, 157, 163, 1);
        cursor: pointer;
        margin-bottom: 10px;
        .icon {
          height: 25px;
          width: 25px;
        }
        &.active,
        &:hover {
          background: rgba(246, 247, 252, 1);
          color: rgba(44, 45, 54, 1);
          border-radius: 8px;
        }
      }
    }
  }
  .main {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    .header {
      box-sizing: border-box;
      padding: 0 20px;
      width: 100%;
      height: 60px;
      background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .user {
        display: flex;
        align-items: center;
        .photo {
          margin-right: 6.7px;
          width: 36px;
          height: 36px;
          border-radius: 18px;
          overflow: hidden;
        }
      }
    }
    .content {
    }
  }
}
</style>
